import React from 'react';
import { Link } from 'react-router-dom';
import ModalItem from '../ModalItem/ModalItem';
import Container from '@material-ui/core/Container';
import { completedRoutes } from '../../../common/constants';
import { Trans, useTranslation } from 'react-i18next';

import '../common.scss';
import './rules.scss';

function Rules() {
  const { t: translation } = useTranslation();
  const t = (str, options) => translation(`rules.${str}`, options);

  return (
    <>
      <ModalItem>
        <>
          <Container className="rules-container">
            <div className="content">
              <h2>{t('h_desc')}</h2>
              <section className="s_hiw">
                <h3>{t('s_hiw.h')}</h3>
                <div className="p">
                  <ul className="ul-img">
                    <li>
                      <div className="li-img-cnt">
                        <div className="ul-title">{t('s_hiw.li1.title')}</div>
                        <span>{t('s_hiw.li1.text')}</span>
                      </div>
                    </li>
                    <li>
                      <div className="li-img-cnt">
                        <div className="ul-title">{t('s_hiw.li2.title')}</div>
                        <span>{t('s_hiw.li2.text')}</span>
                      </div>
                    </li>
                    <li>
                      <div className="li-img-cnt">
                        <div className="ul-title">{t('s_hiw.li3.title')}</div>
                        <span>{t('s_hiw.li3.text')}</span>
                      </div>
                    </li>
                    <li>
                      <div className="li-img-cnt">
                        <div className="ul-title">{t('s_hiw.li4.title')}</div>
                        <span>{t('s_hiw.li4.text')}</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </section>
              <h2>{t('h_rules')}</h2>
              <div className="p">
                <ul className="anchor-links-list">
                    <li><a href="#s_auth">{t('s_auth.h')}</a></li>
                    <li><a href="#s_executing">{t('s_executing.h')}</a></li>
                    <li><a href="#s_moderation">{t('s_moderation.h')}</a></li>
                    <li><a href="#s_appeal">{t('s_appeal.h')}</a></li>
                    <li><a href="#s_payment">{t('s_payment.h')}</a></li>
                    <li><a href="#s_prohibited">{t('s_prohibited.h')}</a></li>
                </ul>
              </div>
              <section id="s_auth" className="anchor">
                <h3>{t('s_auth.h')}</h3>
                <p className="p">
                  <Trans i18nKey="rules.s_auth.p1">
                    %<br/><strong/>%
                  </Trans>
                </p>
                <div className="p">
                  <ol className="numbered-list">
                    <li><Trans i18nKey="rules.s_auth.steps.0">%<strong/>%</Trans></li>
                    <li>{t('s_auth.steps.1')}</li>
                    <li>{t('s_auth.steps.2')}</li>
                  </ol>
                </div>
                <div className="p">
                  <ul className="marked-list">
                    {t('s_auth.comments', { returnObjects: true }).map((i, idx) => {
                      return <li key={idx}>{i}</li>;
                    })}
                  </ul>
                </div>
              </section>
              <section id="s_executing" className="anchor">
                <h3>{t('s_executing.h')}</h3>
                <p className="p">
                  <Trans i18nKey="rules.s_executing.p1">%<br/>%</Trans>
                </p>
                <div className="p">
                  <ol className="numbered-list">
                    <li><Trans i18nKey="rules.s_executing.steps.0">%<Link to={completedRoutes.userTasks}/>%</Trans></li>
                    <li>{t('s_executing.steps.1')}</li>
                    <li><Trans i18nKey="rules.s_executing.steps.2">%<strong/><br/>%</Trans></li>
                    <li><Trans i18nKey="rules.s_executing.steps.3">%<strong/>%</Trans></li>
                  </ol>
                </div>
                <p className="p">
                  <Trans i18nKey="rules.s_executing.p2">%<Link to={completedRoutes.userActivity}/>%</Trans>
                </p>
              </section>
              <section id="s_moderation" className="anchor">
                <h3>{t('s_moderation.h')}</h3>
                <p className="p">{t('s_moderation.p1')}</p>
                <p className="p">
                  <Trans i18nKey="rules.s_moderation.p2">%<strong/>%</Trans>
                </p>
                <p className="p">
                  <Trans i18nKey="rules.s_moderation.p3">%<Link to={completedRoutes.userActivity}/>%</Trans>
                </p>
                <p className="p">
                  <Trans i18nKey="rules.s_moderation.p4">%<span className="mod-balance-text"/><span className="balance-text"/>%</Trans>
                </p>
                <div className="p">
                  <ul className="marked-list">
                    {t('s_moderation.balnce_legend', { returnObjects: true }).map((i, idx) => {
                      return <li key={idx}>{i}</li>;
                    })}
                  </ul>
                </div>
              </section>
              <section id="s_appeal" className="anchor">
                <h3>{t('s_appeal.h')}</h3>
                <p className="p"><Trans i18nKey="rules.s_appeal.p1">%<strong/>%</Trans></p>
                <div className="p">
                  <ol className="numbered-list">
                    <li><Trans i18nKey="rules.s_appeal.steps.0">%<Link to={completedRoutes.userActivity}/>%</Trans></li>
                    <li>{t('s_appeal.steps.1')}</li>
                    <li><Trans i18nKey="rules.s_appeal.steps.2">%<strong/>%</Trans></li>
                    <li>{t('s_appeal.steps.3')}</li>
                    <li><Trans i18nKey="rules.s_appeal.steps.4">%<strong/>%</Trans></li>
                  </ol>
                </div>
                <p className="p">{t('s_appeal.p2')}</p>
                <p className="p"><Trans i18nKey="rules.s_appeal.p3">%<strong/>%</Trans></p>
                <p className="p">{t('s_appeal.p4')}</p>
                <p className="p">{t('s_appeal.p5')}</p>
              </section>
              <section id="s_payment" className="anchor">
                <h3>{t('s_payment.h')}</h3>
                <p className="p"><Trans i18nKey="rules.s_payment.p1">%<Link to={completedRoutes.userPlaces}/>%</Trans></p>
                <p className="p">{t('s_payment.p2')}</p>
                <div className="p">
                  <ol className="numbered-list">
                    <li>{t('s_payment.steps.0')}</li>
                    <li><Trans i18nKey="rules.s_payment.steps.1">%<strong/>%</Trans></li>
                    <li>{t('s_payment.steps.2')}</li>
                    <li>{t('s_payment.steps.3')}</li>
                    <li>{t('s_payment.steps.4')}</li>
                  </ol>
                </div>
                <p className="p"><Trans i18nKey="rules.s_payment.p3">%<Link to={completedRoutes.userActivity}/>%</Trans></p>
              </section>
              <section id="s_prohibited" className="anchor">
                <h3>{t('s_prohibited.h')}</h3>
                <p className="p">{t('s_prohibited.p1')}</p>
                <div className="p">
                  <ul className="marked-list">
                    {t('s_prohibited.actions', { returnObjects: true }).map((i, idx) => {
                      return <li key={idx}>{i}</li>;
                    })}
                  </ul>
                </div>
                <p className="p"><Trans i18nKey="rules.s_prohibited.p2">%<a href="https://likengo.ru/tasks-agreement.html"/>%</Trans></p>
              </section>
            </div>
          </Container>
        </>
      </ModalItem>
    </>
  );
}

export default Rules;
